import Keycloak from 'keycloak-js';

import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);

  redirectToLoginPage(): Promise<void> {
    return this.keycloak.login({ redirectUri: environment.keycloak.redirectUri });
  }

  isLoggedIn(): boolean {
    return !!this.keycloak.authenticated;
  }

  getToken(): string | null {
    return this.keycloak.token ?? null;
  }

  async refreshTokenIfNeeded(): Promise<void> {
    if (this.isTokenExpired()) {
      try {
        await this.keycloak.updateToken(30);
      } catch (error) {
        console.error('Error refreshing token', error);
        throw error;
      }
    }
  }

  logout(): void {
    this.keycloak.logout({ redirectUri: environment.keycloak.postLogoutRedirectUri });
  }

  isTokenExpired(): boolean {
    if (!this.keycloak.tokenParsed || !this.keycloak.tokenParsed.exp) {
      return true;
    }
    const exp = this.keycloak.tokenParsed.exp;
    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  }
}